module.exports = __webpack_public_path__ + "img/logo-white.0c89257d.png";